import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=0131d51c&scoped=true"
import script from "./classification.vue?vue&type=script&lang=js"
export * from "./classification.vue?vue&type=script&lang=js"
import style0 from "./classification.vue?vue&type=style&index=0&id=0131d51c&prod&scoped=true&lang=less"
import style1 from "./classification.vue?vue&type=style&index=1&id=0131d51c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131d51c",
  null
  
)

export default component.exports